

export const ErrorLevel = {
    // Biite weitere Levels ergänzen ...
    warning: '[NIEDRIG]',
    error: '[KRITISCH]',
    info: '[INFO]'
}

export function setErrorLevelAddOn(msg: string, errLvl: string) {
    msg = msg || '';
    if (msg !== "") {
        return errLvl + msg;
    }
    return msg;
}

export function removeErrorLevelAddOn(msg: string) {
    msg = msg || '';
    const key = getErrorLevelKey(msg);
    if (key) {
        const elcopy: any = { ...ErrorLevel };
        msg = msg.substring((elcopy[key] || '').length);
    }
    return msg;
}

export function getErrorLevelKey(msg: string) {
    msg = msg || '';
    const elcopy: any = { ...ErrorLevel };
    const key: string = Object.keys(ErrorLevel).find((k: string) => msg.startsWith(elcopy[k]));
    return key;
}

